import type { ScreenBase } from "@frui.ts/screens/dist";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import type { IModuleViewModel } from "../../types";
import FaultyCombinationsViewModel from "./faultyCombinations/faultyCombinationsViewModel";
import PoliciesViewModel from "./policies/policiesViewModel";

const navigationName = "access-rights";

@Router.registerRoute({ route: navigationName, name: Router.Self, children: [FaultyCombinationsViewModel, PoliciesViewModel] })
export default class AccessRightsViewModel extends ConductorOneChildActive<ScreenBase> implements IModuleViewModel {
  showChildrenSubmenu = true;

  constructor(
    private localizationService: LocalizationService,
    private faultyCombinationsViewModel: FaultyCombinationsViewModel,
    private policiesViewModel: PoliciesViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(this.faultyCombinationsViewModel, this.policiesViewModel);
  }

  @computed
  get name() {
    return this.translate("name");
  }

  protected onInitialize(): Promise<any> | void {
    if (!this.activeChild) {
      this.tryActivateChild(this.children[0]);
    }

    return super.onInitialize();
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.users, `accessRights.${code}`, size);
  }
}
